import * as styles from "./Socials.module.scss";
import React from "react";
import SocialIcon from "./SocialIcon";
import Instagram from "../../../icons/socials/instagram.svg";
import Facebook from "../../../icons/socials/facebook.svg";
import TikTok from "../../../icons/socials/tiktok.svg";
import LinkedIn from "../../../icons/socials/linkedin.svg";
import YouTube from "../../../icons/socials/youtube.svg";

const Socials = ({ share, url, imageUrl }) => {
  const socials = share
    ? [
        {
          social: "Facebook",
          icon: Facebook,
          href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            url
          )}`,
        },
      ]
    : [
        {
          social: "Instagram",
          icon: Instagram,
          href: "https://www.instagram.com/peabodyhogar/",
        },
        {
          social: "Facebook",
          icon: Facebook,
          href: "https://www.facebook.com/peabodyhogar/",
        },
        {
          social: "TikTok",
          icon: TikTok,
          href: "https://www.tiktok.com/@peabodyhogar",
        },
        {
          social: "LinkedIn",
          icon: LinkedIn,
          href: "https://www.linkedin.com/company/goldmund-s-a",
        },
        {
          social: "YouTube",
          icon: YouTube,
          href: "https://www.youtube.com/c/PeabodyHogar",
        },
      ];

  return (
    <div className={styles.socials__container}>
      {socials?.map((s) => {
        return (
          <SocialIcon
            key={s.social}
            icon={s.icon}
            alt={s.social}
            href={s.href}
          />
        );
      })}
    </div>
  );
};

export default Socials;
